import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { LifeStageDateStatusEnum } from "@/Common/Models/LifeStageDateStatusEnum";
import { DateSelector } from "./DateSelector";
import { TextboxControl } from "./TextboxControl";

interface ITextboxControlWithDatePicker {
    dateValue: Date;
    expectedPrecisionMinimum?: LifeStageDatePrecisionEnum
    textValue: string;
    onChange: (dateWithPrecision: DateTimeWithPrecision) => void;
    id: string;
    dataCy?: string;
    disabled?: boolean;
    width?: number;
    isInvalid?: boolean;
    placeholder?: string;
    fullWidth?: boolean;
    height?: number;
    keepWhiteOnDisabled?: boolean;
    cssClass?: string;
    isMonthPicker?: boolean;
    maxDate?: Date;
}

class TextboxControlWithDatePicker extends React.Component<ITextboxControlWithDatePicker, never> {
    public render(): JSX.Element {
        let self = this;
        let widthValue = this.props.width && !isNaN(this.props.width) ? this.props.width + "px" : "126px";
        let heightValue = this.props.height && !isNaN(this.props.height) ? this.props.height + "px" : "36px";
        if (this.props.fullWidth) {
            widthValue = "100%";
        }

        const cssClass = `form-control input
            ${this.props.cssClass ?? ""}
            ${this.props.keepWhiteOnDisabled ? "keep-white-on-disable" : ""}`;

        return (
            <div className="flex-container" style={{ "justifyContent": "flex-start" }}>
                <div style={{ "width": widthValue, position: "relative" }}>
                    <TextboxControl
                        id={"txtdt" + this.props.id}
                        dataCy={this.props.dataCy}
                        IsDate={true}
                        disabled={self.props.disabled}
                        valid={this.props.isInvalid === true ? false : true}
                        value={self.props.textValue}
                        placeholder={this.props.placeholder}
                        ExpectedDatePrecisionMinimum={self.props.expectedPrecisionMinimum}
                        className={cssClass}
                        onChange={(dateWithPrecision: DateTimeWithPrecision) => {
                            self.props.onChange(dateWithPrecision);
                        }}
                        style={{ height: heightValue }}
                    />
                    <div style={{ position: "absolute", top: "6px", right: "6px" }} onClick={() => !self.props.disabled && self.OpenKendoLifeStageDatePicker()}>
                        <span className="k-icon k-i-calendar" />
                        <DateSelector
                            id={"dp" + this.props.id}
                            valid={this.props.isInvalid === true ? false : true}
                            key="kendopicker_LF"
                            date={self.props.dateValue}
                            dateFormat={this.props.isMonthPicker ? "yyyy-MM" : "yyyy-MM-dd"}
                            disabled={self.props.disabled}
                            onChangeCallback={self.onDateChange.bind(self)}
                            constainerStyle={{ "marginTop": "-30px", "height": "0px", "width": "0px", "overflow": "hidden" }}
                            isMonthPicker={this.props.isMonthPicker}
                            maxDate={this.props.maxDate}
                        />
                    </div>
                </div>
            </div>
        );
    }

    public onDateChange(newDate: Date): void {
        const tmpDateWithPrecision = new DateTimeWithPrecision(null, null);
        tmpDateWithPrecision.status = LifeStageDateStatusEnum.Valid;
        tmpDateWithPrecision.precision = this.props.isMonthPicker ? LifeStageDatePrecisionEnum.MonthYear : LifeStageDatePrecisionEnum.DayApprox;
        tmpDateWithPrecision.value = newDate;
        tmpDateWithPrecision.text = newDate?.toMoment().format(this.props.isMonthPicker ? "YYYY-MM" : "YYYY-MM-DD") ?? "";
        tmpDateWithPrecision.isFromDateSelector = newDate.toMoment().isValid();
        this.props.onChange(tmpDateWithPrecision);
    }

    public onDateTextChange(dateWithPrecision: DateTimeWithPrecision): void {
        if (dateWithPrecision.value != null) {
            this.props.onChange(dateWithPrecision);
        }
    }

    public OpenKendoLifeStageDatePicker(): void {
        $(`#dp${this.props.id}`).data("kendoDatePicker").open();
    }
}

export { TextboxControlWithDatePicker };
